export interface PaymentMethodSelectionContext {
	payStoreSelected: boolean;
	creditCardSelected: boolean;
	hasSelectedCard: boolean;
	cardFormIsValid: boolean;
	cardAssociated: boolean;
}

export function canContinueWithPaymentMethod({
	payStoreSelected,
	creditCardSelected,
	hasSelectedCard,
	cardFormIsValid,
	cardAssociated,
}: PaymentMethodSelectionContext): boolean {
	return (
		payStoreSelected ||
		(creditCardSelected && (hasSelectedCard || cardAssociated))
	);
}
